import { Dialog } from '@material-ui/core';
import * as React from 'react';
import { DialogProps } from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';

interface P extends DialogProps {
  overflowYInitial?: boolean;
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
}

/**
 * FreeContentDialogContentを包むためのもの
 * まとめない理由は、分けておくとダイアログが閉じている間に中身を解析するコストが発生しないことと、
 * ダイアログの中身が状態を維持することを防ぐため。特に後者のため。
 * 標準のDialogはmaxWidthを初期値で持つため、意図せずはみ出すことがあるので、falseにする。
 * エスケープ入力でうっかり閉じるとか多くてうざすぎるので枠外クリックとEscapeで閉じないようにする。
 * @param props
 */
const FreeContentDialog = (props: P) => {
  const { overflowYInitial } = props;
  const contentOverflowInitial = useMediaQuery('(min-height:640px)');

  return (
    <Dialog
      maxWidth={false}
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
      PaperProps={
        overflowYInitial && contentOverflowInitial
          ? {
              style: {
                overflowY: 'initial'
              }
            }
          : {}
      }
      {...props}
    />
  );
};

export default FreeContentDialog;
